import { render, staticRenderFns } from "./ImageSlide.vue?vue&type=template&id=2e672d1f"
import script from "./ImageSlide.vue?vue&type=script&lang=js"
export * from "./ImageSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e672d1f')) {
      api.createRecord('2e672d1f', component.options)
    } else {
      api.reload('2e672d1f', component.options)
    }
    module.hot.accept("./ImageSlide.vue?vue&type=template&id=2e672d1f", function () {
      api.rerender('2e672d1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/layerContent/ImageSlide.vue"
export default component.exports